import { FormattedMessage, useIntl } from 'react-intl';
import { Button, Col, Input, Row, Upload, Switch, Card } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import TextArea from 'antd/es/input/TextArea';
import { useCallback } from 'react';
import { CustomFile, ISunkhronosMessage } from '../utils';
import FAIcon from '../../../../common/FAIcon/FAIcon';

interface Props {
    messageData: ISunkhronosMessage[];
    updateData: (data: ISunkhronosMessage[]) => void;
}

const MessagesCompanyDrawer = (props: Props) => {
    const intl = useIntl();

    const updateMessage = useCallback((key: string, changes: Partial<ISunkhronosMessage>) => {
        const updated = props.messageData.map(msg =>
            msg.key === key ? { ...msg, ...changes } : msg
        );
        props.updateData(updated);
    }, [props]);

    const getBase64 = useCallback((file: File, callback: (url: string) => void) => {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result as string));
        reader.readAsDataURL(file);
    }, []);

    return (
        <Row gutter={[10, 10]}>
            <Col xs={{ span: 24 }}>
                <h2><FAIcon prefix='fad' name='message' /> <FormattedMessage defaultMessage="Messages" /></h2>
                {props.messageData.map(message => (
                    <Card
                        key={message.key}
                        size="small"
                        title={
                            <div className="flex-between centerHeight">
                                <span>{intl.formatMessage(message.label)}</span>
                                <Switch
                                    size="small"
                                    checked={message.enabled ?? false}
                                    onChange={() =>
                                        updateMessage(message.key, {
                                            enabled: !message.enabled
                                        })
                                    }
                                />
                            </div>
                        }
                        className="card"
                    >
                        <div className='card-content'>
                        <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '1em' }}>
                            <label><FormattedMessage defaultMessage="Title :" /></label>
                            <Input
                                style={{ marginBottom: 8 }}
                                value={message.realTitle ?? message.title.fr}
                                disabled={!message.enabled}
                                onChange={(e) =>
                                    updateMessage(message.key, { realTitle: e.target.value })
                                }
                            />

                            <label><FormattedMessage defaultMessage="Content :" /></label>
                            <TextArea
                                autoSize={{ minRows: 3 }}
                                style={{ marginBottom: 8 }}
                                value={message.realContent ?? message.content.fr}
                                disabled={!message.enabled}
                                onChange={(e) =>
                                    updateMessage(message.key, { realContent: e.target.value })
                                }
                            />
                        </div>

                        {message.enabledImage ? (
                            <Upload
                                multiple
                                listType="picture"
                                beforeUpload={() => false}
                                onChange={async ({ fileList }) => {
                                    const customFiles: CustomFile[] = await Promise.all(
                                        fileList.map(file => new Promise<CustomFile>((resolve) => {
                                            const origin = file.originFileObj as CustomFile;
                                            getBase64(origin, (base64) => {
                                                origin.blob = base64;
                                                resolve(origin);
                                            });
                                        }))
                                    );

                                    updateMessage(message.key, {
                                        images: customFiles
                                    });
                                }}
                                disabled={!message.enabled}
                            >
                                <Button icon={<UploadOutlined />}><FormattedMessage defaultMessage="Upload Images" /></Button>
                            </Upload>
                        ) : null}
                        </div>
                    </Card>
                ))}
            </Col>
        </Row>
    );
};

export default MessagesCompanyDrawer;
